"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getvalue = void 0;
const _ = __importStar(require("lodash"));
function getvalue(opts) {
    const source = opts.source || 'row';
    const separator = opts.separator || ' ';
    let result;
    if (source === 'row') {
        function getvalueFromRowFormatter(row, cell, value, columnDef, data, grid) {
            return _.get(data, opts.field, '');
        }
        getvalueFromRowFormatter.exportDataFormatter = getvalueFromRowFormatter;
        return getvalueFromRowFormatter;
    }
    function getvalueFormatter(row, cell, value, columnDef, data, grid) {
        if (_.includes(opts.field, ',')) {
            return (_.chain(opts.field.split(','))
                .map(val => _.get(value, val.trim(), null))
                .filter(val => !_.isEmpty(val))
                .join(separator)
                .value() || '');
        }
        return _.get(value, opts.field, '');
    }
    getvalueFormatter.exportDataFormatter = getvalueFormatter;
    return getvalueFormatter;
}
exports.getvalue = getvalue;
//# sourceMappingURL=getvalue.js.map